import { camelize } from '../helpers';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

$(function() {
    // Helpers
    var extractOptionsFromAttributes = function(el, attrPrefix){
        var options = {};

        for (var i = 0; i < el.attributes.length; ++i){
          var attr = el.attributes[i];
          if(attr.name.indexOf(attrPrefix) !== -1 ) {
            var key = camelize(attr.name.replace(attrPrefix, ''));

            options[key] = isNaN(attr.value) ? attr.value : parseFloat(attr.value);
          }
        }

        return options
    }

    /**
     * GSAP AND SCROLLTRIGGER REQUIRED!!!
     * usage:
     * data-knitkit-[SCROLLTRIGGER_OPTION]
     * **/

    var scrollableElements = document.querySelectorAll('[data-knitkit]');

    if(scrollableElements.length && ScrollTrigger) {
        var infinite = function() {return ScrollTrigger.maxScroll(window)};
        var defaults = {
            start: "top top",
            pinSpacing: false,
            end: infinite
        }

        var scrollables = Array.prototype.slice.call(scrollableElements)

        for (var i = 0; i < scrollables.length; ++i) {
            var current = scrollables[i];
            var scrollAction = current.getAttribute('data-knitkit');
            var mediaQuery = current.getAttribute('data-knitkit-media-query');
            var options = Object.assign({}, defaults);
            options = Object.assign({}, options, extractOptionsFromAttributes(current, 'data-knitkit-'));

            // Refactor toggleClass if different target is specified
            var toggleTarget = current.getAttribute('data-knitkit-toggle-class-targets');
            if(toggleTarget && options.toggleClass) {
                options.toggleClass = {
                    targets: toggleTarget,
                    className: options.toggleClass
                }
            }


            // Add trigger if not specified
            options['trigger'] = options.trigger || current

            if(scrollAction === 'pin') {
                options['pin'] = current;
            }

           /*  if(scrollAction === 'fade-in--up') {
                options['start'] = 'top 80%';
                gsap.set(current, {opacity: 0, y: 35});
                options['animation'] = gsap.to(current, 1, {opacity: 1, y: 0});
            } */

            if(mediaQuery) {
                var scrollTriggerMQ = {}
                scrollTriggerMQ[mediaQuery] = function() {
                    ScrollTrigger.create(options);
                }

                ScrollTrigger.matchMedia(scrollTriggerMQ);
            } else {
                ScrollTrigger.create(options);
            }
        }
    }
});
